import { adminAccessUserTypes } from "../constants/action-types"
import {
  addOrgApplicationInstanceEAuthz,
  addUserApplicationInstanceAccessEAuthz,
  getAllAppRolesEAuthz,
  getOrgApplicationAccessStatusEAuthz,
  getUserApplicationInstanceEAuthz,
  getUserGrantedAppRoleEAuthz,
  grantAppRoleToUserEAuthz,
  revokeAppRoleFromUserEAuthz,
  updateOrgApplicationInstanceEAuthz,
  updateUserApplicationInstanceAccessEAuthz,
} from "../../app/services/AdminAccessUser/adminAccessUserApi"
import {
  extractGrantedRoleCodes,
  formatDateForApi,
  formatDateForInput,
  getAccessFinishDate,
  getAccessStatusCode,
  getTodayInputDate,
  isAccessGrantedAndActive,
  isCurrentOrFutureDate,
  // isValidCuit,
  normalizeApiError,
  normalizeCuit,
  pickBestApplicationInstance,
  shouldUpdateAccess,
} from "../../utils/adminAccessUserHelpers"
import { getUserForOrganization } from "./Organizations"
import { helpGetOrganizationWithCUIT } from "../../app/services/Organization/helpGetOrganizationWithCUIT"
import { setErrorTextSnackBar, setRequestTextSnackBar, setSuccessTextSnackBar } from "./app"
import { getApplicationInstance } from "../../app/services/eAuthz/getApplicationInstanceEAuthz"
import { getAllApplicationEAuthz } from "../../app/services/eAuthz/getAllApplicationEAuthz"

export const setAdminAccessCuit = (cuit) => {
  return {
    type: adminAccessUserTypes.ADMIN_ACCESS_SET_CUIT,
    payload: cuit,
  }
}

export const setAdminAccessOrganizationFinishDate = (finishDate) => {
  return {
    type: adminAccessUserTypes.ADMIN_ACCESS_SET_ORG_FINISH_DATE,
    payload: finishDate,
  }
}

export const setAdminAccessUserFinishDate = (finishDate) => {
  return {
    type: adminAccessUserTypes.ADMIN_ACCESS_SET_USER_FINISH_DATE,
    payload: finishDate,
  }
}

export const setAdminAccessSelectedRoles = (selectedRoleCodes) => {
  return {
    type: adminAccessUserTypes.ADMIN_ACCESS_SET_SELECTED_ROLES,
    payload: selectedRoleCodes,
  }
}
export const setAdminAccessAppCode = (appCode) => {
  return {
    type: adminAccessUserTypes.ADMIN_ACCESS_APP_CODE,
    payload: appCode,
  }
}

export const setAdminAccessSelectedUser = (user) => {
  return {
    type: adminAccessUserTypes.ADMIN_ACCESS_SET_SELECTED_USER,
    payload: user,
  }
}

export const clearAdminAccessMessages = () => {
  return {
    type: adminAccessUserTypes.ADMIN_ACCESS_CLEAR_MESSAGES,
  }
}

export const resetAdminAccess = () => {
  return {
    type: adminAccessUserTypes.ADMIN_ACCESS_RESET,
  }
}

const loadOrganizationContextSnapshot = async ({ appCode, organizationId }) => {
  const orgResponse = await getOrgApplicationAccessStatusEAuthz({
    appCode,
    organizationId,
  })

  const orgItems = orgResponse?.data?.data || []
  const orgContainer = Array.isArray(orgItems) ? orgItems[0] : orgItems
  const orgAccess = pickBestApplicationInstance(
    orgContainer?.applicationInstances || [],
  )
  const applicationInstanceId = orgAccess?.applicationInstanceId || ""

  return {
    orgAccess,
    applicationInstanceId,
    orgFinishDate: formatDateForInput(getAccessFinishDate(orgAccess)) || "",
  }
}

const loadUserContextSnapshot = async ({
  appCode,
  userId,
  applicationInstanceId,
}) => {
  let userAccess = null
  let userAppAccessId = ""
  let grantedRoleCodes = []

  if (applicationInstanceId && userId) {
    const userResponse = await getUserApplicationInstanceEAuthz({
      applicationCode: appCode,
      userId,
      applicationInstanceId,
    })
    if (userResponse?.data?.data) {
      const userItems = userResponse?.data?.data?.applicationInstances || []
      // const userContainer = Array.isArray(userItems) ? userItems[0] : userItems
      userAccess = pickBestApplicationInstance(userItems || [])
      userAppAccessId = userAccess?.userAppAccessId || ""


      const grantedRolesResponse = await getUserGrantedAppRoleEAuthz(

        {
          appCode,
          applicationInstanceId,
          userId,
        }
      )


      grantedRoleCodes = extractGrantedRoleCodes(
        grantedRolesResponse?.data?.data,
        userId,
      )
    }
  }

  return {
    userAccess,
    userAppAccessId,
    grantedRoleCodes,
    userFinishDate: formatDateForInput(getAccessFinishDate(userAccess)) || "",
  }
}

export const fetchAdminAccessRoles = (appCode) => {
  return async (dispatch) => {
    dispatch({
      type: adminAccessUserTypes.ADMIN_ACCESS_ROLES_REQUEST,
    })

    try {
      const response = await getAllAppRolesEAuthz(appCode)

      dispatch({
        type: adminAccessUserTypes.ADMIN_ACCESS_ROLES_SUCCESS,
        payload: response?.data?.data || [],
      })

      return response?.data?.data || []
    } catch (error) {
      dispatch({
        type: adminAccessUserTypes.ADMIN_ACCESS_ROLES_FAILURE,
        payload: normalizeApiError(error),
      })

      throw error
    }
  }
}
export const fetchApplicationInstance = (applicationInstanceId) => {
  return async (dispatch) => {
    dispatch({
      type: adminAccessUserTypes.ADMIN_ACCESS_ENABLE_MODULE_REQUEST,
    })
    dispatch({
      type: adminAccessUserTypes.ADMIN_ACCESS_ENABLE_PARAMS_REQUEST,
    })
    try {
      const response = await getApplicationInstance(applicationInstanceId)

      dispatch({
        type: adminAccessUserTypes.ADMIN_ACCESS_ENABLE_MODULE_SUCCESS,
        payload: response?.data?.data?.appModules || [],
      })
      dispatch({
        type: adminAccessUserTypes.ADMIN_ACCESS_ENABLE_PARAMS_SUCCESS,
        payload: response?.data?.data?.appParameters || [],
      })
      return response?.data?.data || null
    } catch (error) {
      dispatch({
        type: adminAccessUserTypes.ADMIN_ACCESS_ENABLE_MODULE_FAILURE,
        payload: normalizeApiError(error),
      })
      dispatch({
        type: adminAccessUserTypes.ADMIN_ACCESS_ENABLE_PARAMS_FAILURE,
        payload: normalizeApiError(error),
      })
    }
  }

}

export const searchOrganizationByCuit = (rawCuit) => {
  return async (dispatch, getState) => {
    dispatch({
      type: adminAccessUserTypes.ADMIN_ACCESS_VALIDATE_ORG_REQUEST,
    })

    try {
      const cuit = normalizeCuit(rawCuit)
      if (!cuit) {
        throw new Error("Debes ingresar un CUIT")
      }

      const organization = await helpGetOrganizationWithCUIT(cuit)

      if (!organization.data?.data?.organizationId) {
        throw new Error(
          "No se encontró una organización para el CUIT ingresado",
        )
      }

      dispatch({
        type: adminAccessUserTypes.ADMIN_ACCESS_VALIDATE_ORG_SUCCESS,
        payload: {
          ...organization.data?.data,
          organizationCuit: organization.data?.data?.organizationCuit || cuit,
        },
      })

      const state = getState()?.adminAccessUser
      const appCode = state?.appCode

      await dispatch(
        refreshAdminAccessOrganizationContext({
          appCode,
          organizationId: organization.data?.data?.organizationId,
        }),
      )

      return organization
    } catch (error) {
      console.log(normalizeApiError(error))
      dispatch({
        type: adminAccessUserTypes.ADMIN_ACCESS_VALIDATE_ORG_FAILURE,
        payload: normalizeApiError(error),
      })

      throw error
    }
  }
}

export const refreshAdminAccessOrganizationContext = ({
  appCode,
  organizationId,
}) => {
  return async (dispatch) => {
    dispatch({
      type: adminAccessUserTypes.ADMIN_ACCESS_ORG_CONTEXT_REQUEST,
    })

    try {
      const snapshot = await loadOrganizationContextSnapshot({
        appCode,
        organizationId,
      })

      let organizationUsers = []

      if (isAccessGrantedAndActive(snapshot?.orgAccess)) {
        const getOrganizationUsers = await dispatch(
          getUserForOrganization(organizationId),
        )
        organizationUsers =
          getOrganizationUsers === "Error" ? [] : getOrganizationUsers
      }

      dispatch({
        type: adminAccessUserTypes.ADMIN_ACCESS_ORG_CONTEXT_SUCCESS,
        payload: {
          ...snapshot,
          organizationUsers,
        },
      })

      return {
        ...snapshot,
        organizationUsers,
      }
    } catch (error) {
      dispatch({
        type: adminAccessUserTypes.ADMIN_ACCESS_ORG_CONTEXT_FAILURE,
        payload: normalizeApiError(error),
      })

      throw error
    }
  }
}

export const enableAdminAccessOrganizationBaseAccess = () => {
  return async (dispatch, getState) => {
    dispatch({
      type: adminAccessUserTypes.ADMIN_ACCESS_ENABLE_ORG_REQUEST,
    })

    try {
      const state = getState()?.adminAccessUser

      const appCode = state?.appCode
      const organizationId = state?.organization?.organizationId
      const orgFinishDate = state?.orgFinishDate

      if (!organizationId) {
        throw new Error("Primero debes buscar y validar una organización")
      }

      if (!orgFinishDate) {
        throw new Error("Debes seleccionar una finishDate para la organización")
      }

      if (!isCurrentOrFutureDate(orgFinishDate)) {
        throw new Error(
          "La fecha de finalización debe ser igual o posterior a la fecha de inicio",
        )
      }

      const startDate = formatDateForApi(getTodayInputDate())
      const finishDate = formatDateForApi(orgFinishDate)

      const currentSnapshot = await loadOrganizationContextSnapshot({
        appCode,
        organizationId,
      })

      if (!currentSnapshot?.applicationInstanceId) {
        await addOrgApplicationInstanceEAuthz({
          appCode,
          organizationId,
          startDate,
          finishDate,
          baseSuborganizationId: null,
          accessStatusCode: "GRANTED",
          productSubscriptionGroupId: null,
          subscriptionTypeRefCode: null,
        })
      } else if (
        shouldUpdateAccess({
          currentStatusCode: getAccessStatusCode(currentSnapshot?.orgAccess),
          currentFinishDate: getAccessFinishDate(currentSnapshot?.orgAccess),
          nextFinishDate: orgFinishDate,
        })
      ) {
        await updateOrgApplicationInstanceEAuthz({
          applicationInstanceId: currentSnapshot.applicationInstanceId,
          accessStatusCode: "GRANTED",
          finishDate,
        })
      }

      await dispatch(
        refreshAdminAccessOrganizationContext({
          appCode,
          organizationId,
        }),
      )

      dispatch({
        type: adminAccessUserTypes.ADMIN_ACCESS_ENABLE_ORG_SUCCESS,
        payload:
          "Acceso base organización / aplicación habilitado correctamente",
      })
      dispatch(setRequestTextSnackBar())
      dispatch(setSuccessTextSnackBar('Acceso base organización / aplicación habilitado correctamente'))
    } catch (error) {
      dispatch({
        type: adminAccessUserTypes.ADMIN_ACCESS_ENABLE_ORG_FAILURE,
        payload: normalizeApiError(error),
      })
      dispatch(setRequestTextSnackBar())
      dispatch(setErrorTextSnackBar("Ocurrió un error. Intente nuevamente."))

      throw error
    }
  }
}

export const refreshAdminAccessSelectedUserContext = ({
  userId,
  applicationInstanceId,
  appCode,
}) => {
  return async (dispatch) => {
    dispatch({
      type: adminAccessUserTypes.ADMIN_ACCESS_USER_CONTEXT_REQUEST,
    })

    try {
      const snapshot = await loadUserContextSnapshot({
        appCode,
        userId,
        applicationInstanceId,
      })

      dispatch({
        type: adminAccessUserTypes.ADMIN_ACCESS_USER_CONTEXT_SUCCESS,
        payload: snapshot,
      })

      return snapshot
    } catch (error) {
      dispatch({
        type: adminAccessUserTypes.ADMIN_ACCESS_USER_CONTEXT_FAILURE,
        payload: normalizeApiError(error),
      })

      throw error
    }
  }
}

export const enableAdminAccessSelectedUserBaseAccess = () => {
  return async (dispatch, getState) => {
    dispatch({
      type: adminAccessUserTypes.ADMIN_ACCESS_ENABLE_USER_REQUEST,
    })

    try {
      const state = getState()?.adminAccessUser

      const appCode = state?.appCode
      const selectedUser = state?.selectedUser
      const applicationInstanceId = state?.applicationInstanceId
      const userFinishDate = state?.userFinishDate

      if (!selectedUser?.userId) {
        throw new Error(
          "Primero debes seleccionar un usuario de la organización",
        )
      }

      if (!applicationInstanceId) {
        throw new Error(
          "La organización no tiene una instancia de aplicación disponible",
        )
      }

      if (!userFinishDate) {
        throw new Error("Debes seleccionar una finishDate para el usuario")
      }

      if (!isCurrentOrFutureDate(userFinishDate)) {
        throw new Error(
          "La fecha de finalización debe ser igual o posterior a la fecha de inicio",
        )
      }

      const startDate = formatDateForApi(getTodayInputDate())
      const finishDate = formatDateForApi(userFinishDate)

      const currentSnapshot = await loadUserContextSnapshot({
        appCode,
        userId: selectedUser.userId,
        applicationInstanceId,
      })

      if (!currentSnapshot?.userAppAccessId) {
        await addUserApplicationInstanceAccessEAuthz({
          applicationInstanceId,
          userId: selectedUser.userId,
          suborganizationId: null,
          accessStatusCode: "GRANTED",
          startDate,
          finishDate,
        })
      } else if (
        shouldUpdateAccess({
          currentStatusCode: getAccessStatusCode(currentSnapshot?.userAccess),
          currentFinishDate: getAccessFinishDate(currentSnapshot?.userAccess),
          nextFinishDate: userFinishDate,
        })
      ) {
        await updateUserApplicationInstanceAccessEAuthz({
          userAppAccessId: currentSnapshot.userAppAccessId,
          accessStatusCode: "GRANTED",
          startDate:
            formatDateForApi(currentSnapshot?.userAccess?.accessStartDate) ||
            startDate,
          finishDate,
        })
      }

      await dispatch(
        refreshAdminAccessSelectedUserContext({
          appCode,
          userId: selectedUser.userId,
          applicationInstanceId,
        }),
      )

      dispatch({
        type: adminAccessUserTypes.ADMIN_ACCESS_ENABLE_USER_SUCCESS,
        payload: "Acceso base usuario / aplicación habilitado correctamente",
      })
      dispatch(setRequestTextSnackBar())
      dispatch(setSuccessTextSnackBar('El acceso del usuario a la aplicación fue habilitado correctamente'))

    } catch (error) {
      dispatch({
        type: adminAccessUserTypes.ADMIN_ACCESS_ENABLE_USER_FAILURE,
        payload: normalizeApiError(error),
      })
      dispatch(setRequestTextSnackBar())
      dispatch(setErrorTextSnackBar("Ocurrió un error. Intente nuevamente."))

      throw error
    }
  }
}

export const submitAdminAccessSelectedUserRoles = () => {
  return async (dispatch, getState) => {
    dispatch({
      type: adminAccessUserTypes.ADMIN_ACCESS_SUBMIT_ROLES_REQUEST,
    })

    try {
      const state = getState()?.adminAccessUser

      const appCode = state?.appCode
      const applicationInstanceId = state?.applicationInstanceId
      const selectedUser = state?.selectedUser
      const selectedRoleCodes = state?.selectedRoleCodes || []

      if (!selectedUser?.userId) {
        throw new Error("Primero debes seleccionar un usuario")
      }

      if (!applicationInstanceId) {
        throw new Error(
          "No hay una instancia de aplicación disponible para la organización",
        )
      }

      if (!selectedRoleCodes.length) {
        throw new Error("Debes seleccionar al menos un rol")
      }

      const refreshedSnapshot = await loadUserContextSnapshot({
        appCode,
        userId: selectedUser.userId,
        applicationInstanceId,
      })

      if (!isAccessGrantedAndActive(refreshedSnapshot?.userAccess)) {
        throw new Error(
          "Primero debes habilitar el acceso base del usuario a la aplicación",
        )
      }

      const missingRoleCodes = selectedRoleCodes.filter((roleCode) => {
        return !refreshedSnapshot?.grantedRoleCodes?.includes(roleCode)
      })

      if (!missingRoleCodes.length) {
        dispatch({
          type: adminAccessUserTypes.ADMIN_ACCESS_USER_CONTEXT_SUCCESS,
          payload: refreshedSnapshot,
        })

        dispatch({
          type: adminAccessUserTypes.ADMIN_ACCESS_SUBMIT_ROLES_SUCCESS,
          payload: "Los roles seleccionados ya estaban asignados",
        })

        return refreshedSnapshot
      }

      for (const roleCode of missingRoleCodes) {
        await grantAppRoleToUserEAuthz({
          applicationInstanceId,
          roleCode,
          userId: selectedUser.userId,
          suborganizationId: null,
        })
      }

      const finalSnapshot = await loadUserContextSnapshot({
        appCode,
        userId: selectedUser.userId,
        applicationInstanceId,
      })

      dispatch({
        type: adminAccessUserTypes.ADMIN_ACCESS_USER_CONTEXT_SUCCESS,
        payload: finalSnapshot,
      })

      dispatch({
        type: adminAccessUserTypes.ADMIN_ACCESS_SUBMIT_ROLES_SUCCESS,
        payload: "Roles asignados correctamente",
      })

      return finalSnapshot
    } catch (error) {
      dispatch({
        type: adminAccessUserTypes.ADMIN_ACCESS_SUBMIT_ROLES_FAILURE,
        payload: normalizeApiError(error),
      })

      throw error
    }
  }
}

export const revokeAdminAccessSelectedUserRole = (roleCode) => {
  return async (dispatch, getState) => {
    dispatch({
      type: adminAccessUserTypes.ADMIN_ACCESS_REVOKE_ROLE_REQUEST,
    })

    try {
      const state = getState()?.adminAccessUser

      const appCode = state?.appCode
      const applicationInstanceId = state?.applicationInstanceId
      const selectedUser = state?.selectedUser

      if (!selectedUser?.userId) {
        throw new Error("Primero debes seleccionar un usuario")
      }

      if (!applicationInstanceId) {
        throw new Error(
          "No hay una instancia de aplicación disponible para la organización",
        )
      }

      if (!roleCode) {
        throw new Error("Debes indicar el rol a revocar")
      }

      await revokeAppRoleFromUserEAuthz({
        applicationInstanceId,
        roleCode,
        userId: selectedUser.userId,
      })

      const finalSnapshot = await loadUserContextSnapshot({
        appCode,
        userId: selectedUser.userId,
        applicationInstanceId,
      })

      dispatch({
        type: adminAccessUserTypes.ADMIN_ACCESS_USER_CONTEXT_SUCCESS,
        payload: finalSnapshot,
      })

      dispatch({
        type: adminAccessUserTypes.ADMIN_ACCESS_REVOKE_ROLE_SUCCESS,
        payload: `Rol ${roleCode} revocado correctamente`,
      })

      return finalSnapshot
    } catch (error) {
      dispatch({
        type: adminAccessUserTypes.ADMIN_ACCESS_REVOKE_ROLE_FAILURE,
        payload: normalizeApiError(error),
      })

      throw error
    }
  }
}


export const fetchAdminApplications = () => {
  return async (dispatch) => {
    dispatch({
      type: adminAccessUserTypes.ADMIN_ACCESS_APPLICATIONS_REQUEST,
    })

    try {
      const response = await getAllApplicationEAuthz()

      dispatch({
        type: adminAccessUserTypes.ADMIN_ACCESS_APPLICATIONS_SUCCESS,
        payload: response?.data?.data || [],
      })

      return response?.data?.data || []
    } catch (error) {
      dispatch({
        type: adminAccessUserTypes.ADMIN_ACCESS_APPLICATIONS_FAILURE,
        payload: normalizeApiError(error),
      })

      throw error
    }
  }
}
